// SoftwareDevelopmentData.js

export const softwareDevelopmentData = {
  hero: {
    eyebrow: "SOFTWARE DEVELOPMENT",
    title: "Powering Businesses With",
    highlightedTitle: "Smart Software Solutions",
    description:
      "Build powerful, scalable, and future-ready software designed around your business goals. From custom platforms to mobile apps, web solutions, CRM systems, and MLM platforms, we turn complex ideas into reliable digital products.",
    primaryButton: "Start Your Project",
    secondaryButton: "Talk to an Expert",
  },

  services: [
    {
      id: "custom-software-development",
      number: "01",
      icon: "code",
      title: "Custom Software Development",
      description:
        "Purpose-built software engineered around your unique workflows, business requirements, and long-term growth.",
      href: "/services/software-development/custom-software",
    },
    {
      id: "mobile-app-development",
      number: "02",
      icon: "mobile",
      title: "Mobile App Development",
      description:
        "Modern iOS and Android applications designed for smooth performance, intuitive experiences, and scalable growth.",
      href: "/services/software-development/mobile-app-development",
    },
    {
      id: "web-development",
      number: "03",
      icon: "web",
      title: "Web Development",
      description:
        "Fast, responsive, secure, and scalable web applications built to deliver powerful digital experiences across devices.",
      href: "/services/software-development/web-development",
    },
    {
      id: "ui-ux-design",
      number: "04",
      icon: "design",
      title: "UI / UX Design",
      description:
        "User-focused interfaces that combine thoughtful experiences, modern aesthetics, usability, and business objectives.",
      href: "/services/software-development/ui-ux-design",
    },
    {
      id: "crm-solutions",
      number: "05",
      icon: "crm",
      title: "CRM Solutions",
      description:
        "Smart customer management platforms that centralize sales, communication, workflows, and business insights.",
      href: "/services/software-development/crm-solutions",
    },
    {
      id: "mlm-software",
      number: "06",
      icon: "mlm",
      title: "MLM Software",
      description:
        "Flexible MLM platforms with network management, commissions, dashboards, automation, and business reporting.",
      href: "/services/software-development/mlm-software",
    },
  ],

  whyChooseUs: [
    {
      number: "01",
      title: "Business-Focused Development",
      description:
        "We understand your business goals first and then engineer technology around the workflows that matter most.",
    },
    {
      number: "02",
      title: "Scalable Architecture",
      description:
        "Our solutions are structured to grow with your users, data, integrations, and future business requirements.",
    },
    {
      number: "03",
      title: "Modern Technology",
      description:
        "We use modern development practices and technologies to create fast, maintainable, and reliable digital products.",
    },
    {
      number: "04",
      title: "User-Centered Experiences",
      description:
        "Every product is designed with usability, accessibility, performance, and a smooth user journey in mind.",
    },
    {
      number: "05",
      title: "Quality & Security",
      description:
        "From development to testing, we focus on dependable performance, clean implementation, and secure application behavior.",
    },
    {
      number: "06",
      title: "Long-Term Support",
      description:
        "Our relationship doesn't end at launch. We help maintain, improve, optimize, and evolve your software over time.",
    },
  ],

  process: [
    {
      step: "STEP 01",
      title: "Discovery & Requirement Analysis",
      description:
        "We understand your business model, objectives, users, challenges, workflows, and technical requirements before development begins.",
    },
    {
      step: "STEP 02",
      title: "Planning & Architecture",
      description:
        "Our team defines the product structure, technology stack, system architecture, integrations, development roadmap, and milestones.",
    },
    {
      step: "STEP 03",
      title: "UI / UX Design",
      description:
        "We transform requirements into intuitive user journeys, wireframes, interfaces, and polished experiences designed around your users.",
    },
    {
      step: "STEP 04",
      title: "Development",
      description:
        "Our developers build the product using clean, scalable, and maintainable code while keeping performance and functionality in focus.",
    },
    {
      step: "STEP 05",
      title: "Testing & Quality Assurance",
      description:
        "Every important feature is tested across functionality, responsiveness, performance, usability, and application behavior.",
    },
    {
      step: "STEP 06",
      title: "Deployment & Launch",
      description:
        "After final validation, we prepare the application for deployment and help ensure a smooth production launch.",
    },
    {
      step: "STEP 07",
      title: "Support & Continuous Improvement",
      description:
        "We continue to support your software with maintenance, improvements, optimization, updates, and future feature development.",
    },
  ],

  faqs: [
    {
      question: "What type of software can you develop?",
      answer:
        "We develop custom business software, web applications, mobile applications, CRM platforms, MLM software, internal business tools, dashboards, automation systems, and other tailored digital solutions.",
    },
    {
      question: "Can you build software from an existing business idea?",
      answer:
        "Yes. We can take your idea, requirements, or existing workflow and help transform it into a structured software product through discovery, planning, design, development, testing, and deployment.",
    },
    {
      question: "Do you provide both web and mobile development?",
      answer:
        "Yes. Our Software Development service covers web applications as well as mobile application development for modern business requirements.",
    },
    {
      question: "Can you integrate third-party APIs and existing systems?",
      answer:
        "Yes. We can design software that integrates with suitable third-party APIs, communication platforms, payment systems, business tools, and existing application infrastructure.",
    },
    {
      question: "Do you provide maintenance after launch?",
      answer:
        "Yes. We can provide ongoing support, maintenance, optimization, updates, troubleshooting, and future feature development after your product is launched.",
    },
  ],

  stats: [
    {
      value: "50+",
      label: "Projects",
    },
    {
      value: "20+",
      label: "Technologies",
    },
    {
      value: "30+",
      label: "Solutions",
    },
    {
      value: "24/7",
      label: "Support",
    },
  ],
};